import React from 'react';

import Text from '../../text/text';

import './lesson-banner-view__info.scss';

interface Props {
    text?: string;
}

export const LessonBannerViewInfo = React.memo(({ text }: Props) => {
    if (!text) {
        return null;
    }

    return (
        <div className="lesson-banner-view__info">
            <Text size={Text.SIZE.S} weight={Text.WEIGHT.M}>
                {text}
            </Text>
        </div>
    );
});
